<div
  class="search-bar-component"
  [ngStyle]="{ width: searchWidthFull ? '100%' : '400px' }"
  style="border-radius: 6px"
  fxFlex.lt-md="auto"
  fxLayout="row"
  fxLayoutAlign="start center"
>
  <button mat-raised-button color="primary" type="button" (click)="select.emit()">
    Sélection d’engagements existants
  </button>
</div>
